import { Grid } from '@mui/material';
import {
  InternacionesTramitesIniciadoAutorizado,
  InternacionesTramitesPorDelegacion,
  InternacionesTramitesProvider,
} from '../components';

export const InternacionesMain = () => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12} md={6}>
        <InternacionesTramitesProvider>
          <InternacionesTramitesIniciadoAutorizado />
        </InternacionesTramitesProvider>
      </Grid>

      <Grid item container spacing={2} xs={12} md={6}>
        <InternacionesTramitesPorDelegacion />
      </Grid>
    </Grid>
  );
};
